module.exports = __webpack_public_path__ + "img/android-done.b9c14acd.svg";